/* ─────────────────────────────────────────────────────────────
   gpc-configurator-showcase.js
   Upload to: Assets/   (paired with sections/gpc-configurator-showcase.liquid)

   This lives in an asset file rather than inline in the section because
   an inline <script> in that section was not being executed on the live
   storefront — the markup and CSS rendered fine, the script sat in the
   DOM untouched, and every click handler was therefore never attached.
   An external file loaded with <script src ... defer> is not subject to
   whatever skipped it, and the boot block at the bottom re-tries on load and on DOM
   mutation in case the section itself turns up late.

   Loaded GLOBALLY from snippets/head.liquid, NOT from the section:
     <script src="{{ 'gpc-configurator-showcase.js' | asset_url }}" defer></script>
   A <script> inside the section never executes on this storefront, inline
   or external. It is never even fetched. Hence loading it globally.

   Do not move this back inline.
   ───────────────────────────────────────────────────────────── */

(function () {
  function init(root) {
    if (root.dataset.gpcsReady === '1') return;
    root.dataset.gpcsReady = '1';

    var dataEl = root.querySelector('[data-gpcs-builds]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gpcs-row]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-gpcs-build]'));
    var nameEl = root.querySelector('[data-gpcs-name]');
    var priceEl = root.querySelector('[data-gpcs-price]');
    var ctaEl = root.querySelector('[data-gpcs-cta]');
    if (!dataEl || !rows.length || !buttons.length) return;

    var builds;
    try { builds = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!builds || !builds.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 2200;

    var selected = 0;   // the build the CTA points at
    var showing = 0;    // the build currently in the panel (may be a hover preview)
    var cursor = [];    // per-row position in that row's list of values
    var timer = null;
    var gen = 0;        // bumped on every build change; stale timeouts check it and bail
    var pointer = 0;
    var paused = false;
    var onScreen = true;

    function rowData(buildIndex, rowIndex) {
      var b = builds[buildIndex];
      return (b && b.rows && b.rows[rowIndex]) || null;
    }

    function valuesFor(buildIndex, rowIndex) {
      var r = rowData(buildIndex, rowIndex);
      return (r && r.v && r.v.length) ? r.v : [''];
    }

    // With price mode "shown", find the variant matching the parts currently on
    // screen and price that exactly. Falls back to the build's From price when
    // no variant matches — which is what happens if a row was removed, or the
    // row is showing fallback values rather than real options.
    var labelFrom = root.getAttribute('data-label-from') || 'From';
    var labelShown = root.getAttribute('data-label-shown') || 'As shown';
    var labelEl = root.querySelector('[data-gpcs-price-label]');

    function exactPrice() {
      var b = builds[showing];
      var mode = root.getAttribute('data-price-mode') || 'from';
      if (mode !== 'shown' || !b || !b.vars || !b.vars.length) return null;

      var wantIdx = [], wantVal = [];
      rows.forEach(function (row, i) {
        var r = rowData(showing, i);
        if (!r || r.o == null || r.o < 0) return;
        wantIdx.push(r.o);
        wantVal.push(valuesFor(showing, i)[cursor[i]]);
      });
      if (!wantIdx.length) return null;

      for (var k = 0; k < b.vars.length; k++) {
        var v = b.vars[k], ok = true;
        for (var n = 0; n < wantIdx.length; n++) {
          if (v.o[wantIdx[n]] !== wantVal[n]) { ok = false; break; }
        }
        if (ok) return v.p;
      }
      return null;
    }

    function updatePrice() {
      if (!priceEl) return;
      var exact = exactPrice();
      priceEl.textContent = exact || builds[showing].price;
      if (labelEl) labelEl.textContent = exact ? labelShown : labelFrom;
    }

    function setRowText(row, text) {
      var el = row.querySelector('[data-gpcs-val]');
      if (el) el.textContent = text;
    }

    // One row changing on its own — the "you can swap this" beat.
    function cycleRow(rowIndex) {
      var row = rows[rowIndex];
      var list = valuesFor(showing, rowIndex);
      if (list.length < 2) return;
      cursor[rowIndex] = (cursor[rowIndex] + 1) % list.length;
      var myGen = gen;

      row.classList.add('is-hot', 'is-out');
      window.setTimeout(function () {
        if (myGen !== gen) return;
        setRowText(row, list[cursor[rowIndex]]);
        row.classList.remove('is-out');
        row.classList.add('is-in');
        updatePrice();
        window.setTimeout(function () { row.classList.remove('is-in'); }, 400);
      }, 210);
      window.setTimeout(function () { if (myGen === gen) row.classList.remove('is-hot'); }, 1500);
    }

    // Every row changing at once — the "this is a different build" beat.
    function showBuild(index, animate) {
      if (index == null || !builds[index]) return;
      showing = index;
      cursor = rows.map(function () { return 0; });
      gen++;
      var myGen = gen;

      rows.forEach(function (row, i) {
        var text = valuesFor(index, i)[0];
        if (!animate || reduce) { setRowText(row, text); return; }
        window.setTimeout(function () {
          if (myGen !== gen) return;
          row.classList.add('is-hot', 'is-out');
          window.setTimeout(function () {
            if (myGen !== gen) return;
            setRowText(row, text);
            row.classList.remove('is-out');
            row.classList.add('is-in');
            window.setTimeout(function () { row.classList.remove('is-in'); }, 400);
          }, 170);
          window.setTimeout(function () { if (myGen === gen) row.classList.remove('is-hot'); }, 900);
        }, i * 28);
      });

      var b = builds[index];
      if (nameEl) { nameEl.textContent = b.name; nameEl.setAttribute('href', b.url); }
      if (ctaEl) ctaEl.setAttribute('href', b.cfg);
      updatePrice();
      pointer = 0;
    }

    /* ── accordion: on narrow screens the panel lives inside the list, ──
       ── directly under whichever build is open                        ── */
    var picker = root.querySelector('.gpcs-picker');
    var slot = root.querySelector('[data-gpcs-slot]');
    var stackedMQ = window.matchMedia('(max-width: 960px)');

    // Normally the media query decides. data-force-stacked lets a preview
    // harness that fakes a viewport width drive it instead; it is never set
    // on a real storefront.
    function isStacked() {
      var forced = root.getAttribute('data-force-stacked');
      if (forced === 'true') return true;
      if (forced === 'false') return false;
      return stackedMQ.matches;
    }

    // Release the pinned height once the transition lands, so the panel can
    // grow on its own afterwards (a row wrapping, the price getting longer).
    function releaseHeight(e) {
      if (e && e.propertyName !== 'height') return;
      if (slot.style.height !== '0px') slot.style.height = '';
    }
    if (slot) slot.addEventListener('transitionend', releaseHeight);

    function naturalHeight() {
      var prev = slot.style.height;
      slot.style.height = 'auto';
      var h = slot.getBoundingClientRect().height;
      slot.style.height = prev;
      return h;
    }

    function openSlot() {
      window.clearTimeout(slot.gpcsTimer);
      if (reduce) { slot.style.height = ''; return; }
      var target = naturalHeight();
      slot.style.height = '0px';
      void slot.offsetHeight;                      // force the start frame
      slot.style.height = target + 'px';
      // belt and braces if transitionend never fires (tab backgrounded mid-open)
      slot.gpcsTimer = window.setTimeout(releaseHeight, 420);
    }

    var collapsed = false;

    function markButtons() {
      buttons.forEach(function (btn, i) {
        var on = i === selected && !collapsed;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', String(on));
        btn.setAttribute('aria-expanded', String(on));
      });
    }

    function closeSlot() {
      collapsed = true;
      markButtons();
      window.clearTimeout(slot.gpcsTimer);
      slot.style.height = naturalHeight() + 'px';
      void slot.offsetHeight;
      slot.style.height = '0px';
    }

    function positionSlot(index, animate) {
      if (!slot || !picker) return;
      if (!isStacked()) {
        // side by side: the panel always shows, there is nothing to close
        collapsed = false;
        markButtons();
        window.clearTimeout(slot.gpcsTimer);
        slot.style.height = '';
        if (picker.nextElementSibling !== slot) picker.insertAdjacentElement('afterend', slot);
        return;
      }
      var btn = buttons[index];
      if (!btn) return;

      // Landing on a phone, or switching over to the stacked layout, every
      // build starts closed — the list reads as a menu rather than one
      // machine already unpacked.
      if (!animate) {
        collapsed = true;
        markButtons();
        if (btn.nextElementSibling !== slot) btn.insertAdjacentElement('afterend', slot);
        window.clearTimeout(slot.gpcsTimer);
        slot.style.height = '0px';
        return;
      }

      if (btn.nextElementSibling === slot) { openSlot(); return; }
      btn.insertAdjacentElement('afterend', slot);
      openSlot();
    }

    function select(index) {
      // Tapping the build that is already open closes it — that is what the
      // caret promises. Side by side there is no closed state.
      if (isStacked() && index === selected && !collapsed) { closeSlot(); return; }
      collapsed = false;
      selected = index;
      markButtons();
      var stacked = isStacked();
      positionSlot(index, true);
      // Side by side, the per-row swap IS the transition. In the accordion the
      // panel sliding open is, and staggering 7 rows on top of it just costs
      // frames on a phone.
      showBuild(index, !stacked);
    }

    // Click only. Hover used to preview a build, but a panel that changes as
    // the cursor crosses the list is restless and makes the click feel like it
    // did nothing — the panel was already showing that machine.
    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { select(i); });
    });

    var track = root.querySelector('[data-gpcs-track]');

    /* ── the idle cycle ──────────────────────────────────── */
    function tick() {
      if (paused || !onScreen) return;
      var tries = 0;
      while (tries < rows.length) {
        var i = pointer % rows.length;
        pointer++;
        tries++;
        if (valuesFor(showing, i).length > 1) { cycleRow(i); return; }
      }
    }

    if (!reduce) {
      timer = window.setInterval(tick, interval);
      var panel = root.querySelector('[data-gpcs-panel]');
      if (panel) {
        panel.addEventListener('mouseenter', function () { paused = true; });
        panel.addEventListener('mouseleave', function () { paused = false; });
      }
      document.addEventListener('visibilitychange', function () { paused = document.hidden; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { onScreen = entry.isIntersecting; });
        }, { threshold: 0.2 }).observe(root);
      }
    }

    cursor = rows.map(function () { return 0; });
    updatePrice();
    positionSlot(selected, false);
    if (stackedMQ.addEventListener) {
      stackedMQ.addEventListener('change', function () { positionSlot(selected, false); });
    } else if (stackedMQ.addListener) {
      stackedMQ.addListener(function () { positionSlot(selected, false); });
    }

    // Lets the theme editor (or anything else) force a price refresh after
    // changing data-price-mode, without waiting for the next swap.
    root.addEventListener('gpcs:refresh', updatePrice);
    root.addEventListener('gpcs:relayout', function () { positionSlot(selected, false); });

    /* ── picker scroll arrows ────────────────────────────── */
    var nav = root.querySelector('[data-gpcs-nav]');
    var prev = root.querySelector('[data-gpcs-prev]');
    var next = root.querySelector('[data-gpcs-next]');
    if (track && nav && prev && next) {
      function vertical() { return track.scrollHeight - track.clientHeight > 4; }
      function horizontal() { return track.scrollWidth - track.clientWidth > 4; }

      function sync() {
        var v = vertical(), h = horizontal();
        nav.hidden = !(v || h);
        if (nav.hidden) return;
        var pos = v ? track.scrollTop : track.scrollLeft;
        var max = v ? track.scrollHeight - track.clientHeight : track.scrollWidth - track.clientWidth;
        prev.disabled = pos <= 2;
        next.disabled = pos >= max - 2;
      }

      function page(dir) {
        var card = track.querySelector('.gpcs-build');
        if (vertical()) {
          var stepY = card ? card.getBoundingClientRect().height + 8 : track.clientHeight * 0.8;
          track.scrollBy({ top: dir * stepY * 2, behavior: reduce ? 'auto' : 'smooth' });
        } else {
          var stepX = card ? card.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
          track.scrollBy({ left: dir * stepX, behavior: reduce ? 'auto' : 'smooth' });
        }
      }

      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
      sync();
    }
  }

  function initAll(scope) {
    var found = 0;
    (scope || document).querySelectorAll('[data-gpcs-root]').forEach(function (el) {
      init(el);
      found++;
    });
    return found;
  }

  // Belt and braces on WHEN this runs. The section can be on the page already,
  // arrive during parsing, or be injected later by the theme, an app or the
  // section rendering API — so try at every one of those moments and stop
  // watching once something has actually been initialised.
  // Stamped so you can confirm which build the store is actually serving:
  // type  window.GPCS_VERSION  in the console. 'click-only' means hover no
  // longer previews a build. If it is undefined or older, the asset did not
  // get re-pasted.
  window.GPCS_VERSION = '2026-08-13 click-only';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  window.addEventListener('load', function () { initAll(); });

  // Loaded globally from head.liquid, so this runs on pages with no widget at
  // all. Watch briefly for one appearing, coalesce bursts of DOM changes into a
  // single check, and stop as soon as one is found or after 15 seconds.
  if ('MutationObserver' in window) {
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        if (initAll()) mo.disconnect();
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { mo.disconnect(); }, 15000);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
